<template>
  <div id="tags-view-container" class="tags-view-container" ref="tagsContainer">
    <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTag" @tab-click="gotoRuter"
      @contextmenu.prevent.native="openMenu($event)">
      <el-tab-pane ref="tag" v-for="tag in visitedViews" :key="tag.name" :label="$lang(tag.meta.title)" :name="$lang(tag.name)"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }">
      </el-tab-pane>
    </el-tabs>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">{{$lang('刷新')}}</li>
      <li v-if="!(selectedTag.meta&&selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">{{$lang('关闭')}}</li>
      <li @click="closeOthersTags">{{$lang('关闭其他')}}</li>
      <li @click="closeAllTags(selectedTag)">{{$lang('关闭所有')}}</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import path from 'path'

export default {
  name: 'Tagbar',
  props: ['isCollapse'],
  data() {
    return {
      visible: false,
      top: 110,
      left: 65,
      selectedTag: {},
      affixTags: [],
      tagWidth: 'width:auto',
      editableTabsValue: '',
    }
  },
  computed: {
    // 属性visitedViews为想要获取的属性名
    // 值‘visitedViews’为getters.js里面定义的属性名称
    ...mapGetters({
      visitedViews: 'visitedViews',
      cachedViews: 'cachedViews',
      user: 'user',
    }),
  },
  watch: {
    $route() {
      this.addTags()
      this.editableTabsValue = this.$route.name
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
  },
  created: function() {
    this.editableTabsValue = this.$route.name
  },
  mounted: function() {
    this.addTags()
  },
  destroyed() {
    // 清除定时任务/绑定事件/eventBus事件
    document.body.removeEventListener('click', this.closeMenu)
  },
  methods: {
    ...mapActions(['ADD_VIEW', 'DEL_VIEW', 'DEL_CACHED_VIEW', 'DEL_OTHERS_VIEWS', 'DEL_ALL_VIEWS']),
    removeTag(targetName) {
      const tabs = this.visitedViews
      tabs.forEach((tab, index) => {
        if (tab.name === targetName) {
          this.closeSelectedTag(tabs[index])
        }
      })
    },
    gotoRuter(view) {
      this.$router.push({ path: view.$attrs.to.path })
    },
    // tag为活动
    isActive(route) {
      return route.path === this.$route.path
    },
    // 找到需要固定显示的tag
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta },
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    // 增加标签
    addTags() {
      const { name } = this.$route
      if (name) {
        this.ADD_VIEW(this.$route)
        this.setTagsWidth()
      }
      return false
    },
    // 设置页签宽度
    setTagsWidth() {
      const w = this.$refs.tagsContainer.offsetWidth / this.visitedViews.length
      if (w > 200) return
      this.tagWidth =
        'width:' + (w / this.$refs.tagsContainer.offsetWidth) * 100 + '%'
    },
    // 刷新当前页
    refreshSelectedTag(view) {
      const { fullPath } = view
      this.DEL_CACHED_VIEW(view).then(() => {
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath,
          })
        })
      })
    },
    // 关闭标签页
    closeSelectedTag(view) {
      this.DEL_VIEW(view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
          this.setTagsWidth()
        }
      })
    },
    // 关闭其他标签页
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.DEL_OTHERS_VIEWS(this.selectedTag).then(() => {})
    },
    // 关闭所有标签页
    closeAllTags(view) {
      this.DEL_ALL_VIEWS().then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        this.$router.replace({ path: '/redirect/dashboard' })
      }
    },
    // 点击右键
    openMenu(e) {
      if (e.target.getAttribute('role') === 'tab') {
        const id = e.target.id
        const name = id.replace('tab-', '')
        const menuMinWidth = 15
        const offsetWidth = this.$el.offsetWidth
        const maxLeft = offsetWidth - menuMinWidth
        const wd = this.isCollapse ? 80 : 200
        const left = e.clientX - wd
        if (left > maxLeft) {
          this.left = maxLeft
        } else {
          this.left = left
        }
        this.top = e.clientY + 20
        this.visible = true
        const tabs = this.visitedViews
        tabs.forEach((tab, index) => {
          if (tab.name === name) {
            this.selectedTag = tab
          }
        })
      }
    },
    closeMenu() {
      this.visible = false
    },
  },
}
</script>
<style lang="scss">
$tag-height: 48px;
.navTab {
    border-bottom: 1px solid #edeef3;
    overflow: hidden;
    padding: 0 20px;
    box-sizing: border-box;
}
.tags-view-container {
  height: $tag-height;
  width: 100%;

//   background: #27262C;
  .el-tabs {
    // padding: 8px 4px 0 4px;
    box-sizing: border-box;
        padding-top: 7px;
        height: 100%;
    .el-tabs__header {
      border-bottom: none;
      margin: 0;
      .el-tabs__nav-wrap {
        .el-tabs__nav-prev {
          display: none;
          width: 10px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #fff;
          border-radius: 4px;
          margin-top: 4px;
          .el-icon-arrow-left {
             font-size: 10px;
            color: #000000 !important;
          }
        }
        .el-tabs__nav-next {
          display: none;
          width: 10px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin-top: 4px;
          background-color: #fff;
           border-radius: 4px;
          .el-icon-arrow-right {
            font-size: 10px;
            color: #000000 !important;
          }
        }
        &:hover,&:focus{
          .el-tabs__nav-prev,.el-tabs__nav-next {
            display: block
          }
        }
        .el-tabs__nav-scroll {
          width: 100%;
          margin: auto;
          .el-tabs__nav {
            border: none;
            overflow: hidden;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            .el-tabs__item {
              height: 41px;
              line-height: 40px;
              padding: 0px 20px;
              padding-right: 25px;
              border-left: none;
              border-bottom: none;
              font-weight: 500;
              text-align: center;
              overflow: hidden;
              -o-text-overflow: ellipsis;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #303133;
              margin-right: 1px;
              .el-icon-close {
                position: absolute;
                width: 14px!important;
                top: 12px;
                right: 5px;
              }
            }
            .is-active {
            //   color: #333;
               padding-right: 25px;
            //   background-color: #F4F4F4;
                color: #e60012;
                background: #fff;
                border: 1px solid #eee;
                border-top: 2px solid #e60012;
                border-bottom: 0;
                padding-left: 15px;
                font-weight: 600;
            // padding-right: 15px;
            }
          }
        }
      }
      .is-scrollable {
        .el-tabs__nav-scroll {
          width: 99%;
        }
      }
    }
  }
  .tags-view-item {
    &:first-child {
      .tag-item {
        margin-left: 0;
      }
    }
    display: inline-block;
    position: relative;
    cursor: pointer;
    .tag-item {
      display: block;
      width: 125px;
      height: $tag-height;
      line-height: $tag-height;
      color: #999999;
      background: #eeeeee;
      font-size: 14px;
      margin-left: 6px;
      // border-radius: 5px 5px 0px 0px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // max-width: 200px;
    }
    &.active {
      .tag-item {
        background-color: #a5acc8;
        color: #ffffff;
        // color: $--color-theme;
        border-color: #fff;
      }
    }
    .title {
      padding: 0 5px 0 10px;
    }
  }
  // }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

